import { SITE, scrollToId } from "@/config";
import BrandMark from "@/components/BrandMark";

const Header = () => (
  <header
    data-testid="header-navbar"
    className="fixed inset-x-0 top-0 z-50 border-b border-gold/15 bg-ivory/85 backdrop-blur-md"
  >
    <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
      <a
        data-testid="header-brand-link"
        href="#top"
        onClick={(e) => {
          e.preventDefault();
          scrollToId("#top");
        }}
        className="flex items-center"
      >
        <BrandMark />
      </a>
      <div className="flex items-center gap-5">
        <a
          data-testid="header-buy-now-button"
          href={SITE.razorpayUrl}
          target="_blank"
          rel="noopener noreferrer"
          className="rounded-full bg-navy px-5 py-2 text-xs font-bold uppercase tracking-[0.18em] text-ivory transition-colors duration-300 hover:bg-navy-deep"
        >
          Buy Now — {SITE.price}
        </a>
      </div>
    </div>
  </header>
);

export default Header;
